<div class="input-group">
    <span class="input-group-addon flagInput">
        <div class="dropdown">
            <button type="button" class="dropbtn btn" (click)="displayDropDown()">
                <span [class]="'flag flag-' + selectedCountry.countryCode" *ngIf="selectedCountry"></span>
                <span class="defaultCountry" *ngIf="!selectedCountry"></span>
                <span class="arrow-down"></span>
            </button>
            <div class="dropdown-content" *ngIf="showDropdown" clickOutside>
                <div class="list-group scrollable-menu">
                    <a href="#" class="list-group-item" *ngFor="let country of countries | country: countryFilter"
                        (click)="updateSelectedCountry($event, country.countryCode)">
                        <span [class]="'flag flag-' + country.countryCode"></span>
                        <span class="country-name">{{ country.name }} <span class="dial-code">+ {{
                                country.dialCode}}</span></span>
                    </a>
                </div>
            </div>
        </div>
    </span>

    <label id='dial-code' *ngIf=dialCode>+{{dialCode}}</label>

    <!-- domestic, required, uses masking directive -->
    <input *ngIf="required && !isForeign()" phone required name="primaryPhoneInput" id="primaryPhoneInput"
        placeholder='{{placeholder}}' mask="000-000-0000" [(ngModel)]="phoneNumberOnly"
        aria-label='phone number' #phoneNumberInput type="text" (ngModelChange)=updatePhoneNumber($event)
        (blur)=blur() />
    <!-- Foreign, required, since foreign countries can have different length phones, potentially from 5 to 12 digits, remove the masking and enforce a max of 12 numeric digits. Rely on google-libphonenumber for validation. -->
    <input *ngIf="required && isForeign()" phone required name="primaryPhoneInput" id="primaryPhoneInput"
        placeholder='{{placeholder}}' maxlength='{{maxlength}}'
        onkeypress='return event.charCode >= 48 && event.charCode <= 57' [(ngModel)]="phoneNumberOnly"
        aria-label='phone number' #phoneNumberInput type="text" (ngModelChange)=updatePhoneNumber($event)
        (blur)=blur() />

    <!-- domestic, not required -->
    <input *ngIf="!required && !isForeign()" phone name="primaryPhoneInput" id="primaryPhoneInput"
        placeholder='{{placeholder}}' mask="000-000-0000" [(ngModel)]="phoneNumberOnly"
        aria-label='phone number' #phoneNumberInput type="text" (ngModelChange)=updatePhoneNumber($event)
        (blur)=blur() />
    <!-- foreign, not required -->
    <input *ngIf="!required && isForeign()" phone name="primaryPhoneInput" id="primaryPhoneInput"
        placeholder='{{placeholder}}' maxlength='{{maxlength}}'
        onkeypress='return event.charCode >= 48 && event.charCode <= 57' [(ngModel)]="phoneNumberOnly"
        aria-label='phone number' #phoneNumberInput type="text" (ngModelChange)=updatePhoneNumber($event)
        (blur)=blur() />
</div>
